export default __webpack_public_path__ + "static/avatar-kayi-special-1-cover-072b05e152d80a2ba2a02325b6dcad49.png";